module.exports = __webpack_public_path__ + "static/media/hummingbird.77c05622.svg";